<template>
<div class="app has-tab-menu">
    <div class="header">
        <menutabs :state="{tabs: tabs}" :tab-selected="tabSelected" @tab-select="UpdateSelectedView" :disabled="!allowContentSwitch"></menutabs>
    </div>
    <component :is="tabSelected.view"/>
</div>
</template>

<script>


import preferenceview from '../preferencecontext/PreferenceView.vue'
import vacationoverview from '../preferencecontext/VacationOverview.vue'
import vacationbanoverview from '../preferencecontext/VacationBanOverview.vue'
import { mapState, mapGetters } from 'vuex';

export default {
    components: {
        preferenceview,
        vacationoverview,
        vacationbanoverview
    },
    name: 'PreferenceMain',
    data() {
        return {
            loading: true,
            tabSelected: null,
        }
    },
    watch: {},
    computed: {
        ...mapGetters(['storeId', 'isSuperUser', 'allowContentSwitch']),
        tabs() {
            let tabs = [{label: this.$t('shift.template.view'), view: 'preferenceview', selected: true, margin: true}];
            tabs.push({label: this.$t('pref.main.block'), view: 'vacationbanoverview', margin: true})
            tabs.push({label: this.$t('pref.main.vacOverview'), view: 'vacationoverview', margin: true});
            
            if(this.isSuperUser){
                tabs.push({label: this.$t('pref.main.overview'), view: 'employeepreferenceoverview', margin: true, 'onlyAdmin' : true});
               
            } 
            return tabs;
        }
    },
    props: ['view', 'currentDay'],
    created() {
        let view = this;
        if(this.$router.currentRoute.params.tab){
            let tab = this.tabs.find(t => t.view === view.$router.currentRoute.params.tab);
            if(tab){
                this.tabSelected = tab;
            }
        } else {
            let tab = this.tabs.find(t => t.selected);
            if(tab) this.tabSelected = tab;
            else this.tabSelected = {view: this.view ? this.view : 'roster'};
        }
    },
    mounted(){

    },

    updated() {},
    destroyed() {},
    methods: {
        UpdateSelectedView(tab){
            this.tabs.forEach(t => t.selected = false);
            tab.selected = true;
            this.tabSelected = tab;
        }
    }
}
</script>
